import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { forwardRef } from 'react';
import { Container } from '../Container.js';
export const IconAddCircle = forwardRef((props, ref) => _jsx(Container, {
  "data-testid": "IconAddCircle",
  ref: ref,
  ...props,
  children: _jsx("path", {
    d: "M440-440v120q0 17 12 29t28 11 29-11 11-29v-120h120q17 0 29-11t11-29-11-28-29-12H520v-120q0-17-11-28t-29-12-28 12-12 28v120H320q-17 0-28 12t-12 28 12 29 28 11zm40 360q-83 0-156-31t-127-86-85-127-32-156 32-156 85-127 127-85 156-32 156 32 127 85 86 127 31 156-31 156-86 127-127 86-156 31"
  })
}));